import React from 'react';
import cx from 'classnames';
import styles from './Switch.module.css';

type SwitchProps = {
	name: string;
	checked: boolean;
	onChange: (data: boolean) => void;
	isPointerDisabled?: boolean;
};

const Switch: React.FC<SwitchProps> = ({
	name,
	checked,
	onChange,
	isPointerDisabled = false,
}) => {
	return (
		<div className={styles.switchContainer}>
			<label
				className={cx(
					styles.toggleSwitchLabel,
					isPointerDisabled ? styles.isPointerDisabled : styles.pointer
				)}
				htmlFor={name}
			>
				<input
					className={
						isPointerDisabled
							? styles.toggleSwitchCheckboxDisabled
							: styles.toggleSwitchCheckbox
					}
					id={name}
					type="checkbox"
					checked={checked}
					onChange={(e) => onChange(e.target.checked)}
				/>
				<span className={styles.toggleSwitchButton} />
			</label>
		</div>
	);
};

export default Switch;
